<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <div class="col-md-4">
      <h3 class="ls-title-4">{{ $t('settings.main.edit_payment_method') }}</h3>
      <p>{{ $t('settings.label.set_configurations') }}</p>
    </div>
    <div class="col-md-8">
      <div v-for="customField in customFields">
        <label class="ls-label col-md-6">
          <b class="ls-label-text">{{ customField.name }}</b>
          <input type="text" :name="customField.tag" v-model="customField.value">
        </label>
      </div>
      <div class="ls-actions-btn">
        <div class="ls-float-right">
          <router-link :to='"/settings/payment_settings/" + payment.processor + "/show"'class="ls-btn" :title="$t('application.menu.payment_settings')">{{ $t('application.button.back') }}</router-link>
          <a href="javascript:void(0)" class="ls-btn-primary" @click="saveSetting()">{{ $t('application.button.save') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'

  export default {
    name: 'edit-payment-method',
    components: { Breadcrumb },
    computed: {
      ...mapGetters(['customFields', 'customFieldsValues'])
    },
    data () {
      return {
        payment: {},
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.edit_payment_method'),
          'paths': {
            0: {
              'title': this.$t('settings.main.select_payment_method'),
              'path': '/settings/payment_settings'
            },
            1: {
              'title': this.$t('settings.main.payment_acquirer'),
              'path': '/settings/payment_settings/index'
            },
            2: {
              'title': this.$t('settings.main.payment_methods'),
              'path': '/settings/payment_settings/' + this.$route.params.processor + '/show'
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['loadCustomFields', 'loadCustomFieldsValues', 'updatePaymentMethods']),
      saveSetting () {
        this.$loader.show()
        let params = { tags: [], methods: [this.payment.paymentMethod], processor: this.$route.params.processor }
        for (var i = 0; i < this.customFields.length; i++) {
          params.tags[i] = { tag: this.customFields[i].tag, value: this.customFields[i].value }
        }
        this.updatePaymentMethods(params).then(this.$router.push('/settings/payment_settings/' + this.$route.params.processor + '/show'))
      },
      setCustomFieldValue () {
        if (!this.customFieldsValues[0]) {
          this.$loader.hide()
          return
        }

        for (var i = 0; i < this.customFields.length; i++) {
          var self = this
          this.customFieldsValues.filter((setting) => {
            if (self.customFields[i].tag === setting.tag) {
              self.customFields[i].value = setting.value
              self.customFields.splice(i, 1, self.customFields[i])
            }
          })
        }
        this.$loader.hide()
      }
    },
    mounted () {
      this.$loader.show()
      this.payment = { processor: this.$route.params.processor, paymentMethod: this.$route.params.method }
      this.loadCustomFieldsValues(this.payment).then(fun => {
        this.loadCustomFields(this.payment).then(this.setCustomFieldValue)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// EditPaymentSettings.vue?4427e210